import React, { useMemo } from "react";

//UI
import { Select } from "antd";

//processing
import { useGetAllCustomers } from "../../../hooks/Onboarding/onboarding.hooks";

const { Option } = Select;

const CustomerDropdown = (props) => {
  const { setCustomer, customer } = props;

  const { data: customerData, isLoading: isLoadingCustomer } =
    useGetAllCustomers();

  const CustomersList = useMemo(() => {
    if (Array.isArray(customerData)) {
      return customerData
        .sort((a, b) => a.customer_name.localeCompare(b.customer_name))
        .map((customer) => (
          <Option key={customer._id} value={customer._id}>
            {customer.customer_name}
          </Option>
        ));
    }
  }, [customerData]);

  return (
    <Select
      name="searchCustomer"
      onChange={setCustomer}
      loading={isLoadingCustomer}
      showSearch
      value={customer}
      defaultValue="All"
      placeholder="Customer"
      optionFilterProp="children"
      filterOption={(input, option) => {
        return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
      }}
    >
      <Option value="">All</Option>
      {CustomersList}
    </Select>
  );
};

export default CustomerDropdown;
